module.exports = __webpack_public_path__ + "static/media/21ECLAC2.9096b832.jpg";